import { useQuery, UseQueryResult } from 'react-query';
import { AttendanceRuleRetrieve, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAttendanceRulesProps {
  packageId: string;
}

function useAttendanceRules({ packageId }: IUseAttendanceRulesProps): UseQueryResult<{
  data: Array<AttendanceRuleRetrieve>;
}> {
  const params: UrlParams = {
    package: packageId,
  };

  return useQuery(['attendance-rules', packageId], () =>
    client.get(`attendance-rules/?${encodeUrlParams(params)}`),
  );
}

export default useAttendanceRules;
